// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"30d0cc23","839":"50bd5d03"}[chunkId] + ".chunk.js";
};